module.exports = __webpack_public_path__ + "static/media/why_we_choose.9ba7b95a.png";